import { useMutation } from "react-query";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { declarePaymentCompletedAndForwardToChamber } from "src/violationCase/data-access/gateway";
import { useNavigate } from "react-router-dom";

export default function useDeclarePaymentCompletedAndForwardToChamber(
  caseId: string,
) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: declarePaymentCompletedAndForwardToChamber,
    mutationKey: ["declarePaymentCompletedAndForwardToChamber", caseId],
    onSuccess: async () => {
      enqueueSnackbar(
        t(
          "Επιτυχής Δήλωση πληρωμής και προώθηση στην αρμόδια Υ.Γ.Ε.ΜΗ. για έλεγχο",
        ),
        {
          variant: "success",
        },
      );
      navigate("/violation/company/casesDashboard");
    },
  });
}
